import FormConstructor from '@/common/containers/FormConstructor/FormConstructor';

export default FormConstructor;
